import { useEffect } from 'react'

export const usePreDocument = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
